module.exports = __webpack_public_path__ + "static/media/office1.6bb0b5d0.jpg";